<div class="chat-width-a">
    <h2 mat-dialog-title class="md-title chat-cont-a">
        <img src='../../assets/images/logoclaro2.png' style='width:32px;height:32px; vertical-align: middle;'>
        <label class='labTitle chatTitle-b'>Validación de Cuentas Programa de Referidos</label>
    </h2>
    <mat-dialog-content class="chat-cont-a">
        <div class="chatJAC">
            <div class="popupbg">
                <div class="popupcont f-reg f-black roboto-r">
                    <div class="basicrow m-bott-ii">
                        <div class="basicrow m-top">
                            <label class="label-f">
                                &#42; Seleccione Cuenta
                            </label>
                            <div class="basicrow">
                                <select [(ngModel)]="this.selectBan" (change)="this.refreshDataTo()" class="sel-f"
                                    style="background-image:url(/assets/images/selectabarrw.png)">
                                    <option *ngFor="let list of this.currentList" [ngValue]="list.account">
                                        {{list.account}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="basicrow m-top-i">
                            <label class="label-f">
                                &#42; Seleccione Número de Teléfono 
                            </label>
                            <select class="sel-f" [(ngModel)]="this.subscriber">
                                <option *ngFor="let inf of this.info" [ngValue]="inf.subscriberNumberField">
                                    {{inf.subscriberNumberField}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="basicrow m-top">
                        <div class="logline full"></div>
                    </div>
                    <div class="basicrow text-center m-top">
                        <a class="btns def-i red pull-right vcenter" (click)="this.validateData();">
                            <span class="tabcell">
                                Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                            </span>
                        </a>
                        <a class="btns def-i gray pull-left vcenter" (click)="this.close();">
                            <span class="tabcell">
                                Cancelar
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>
</div>